/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useContext, useEffect, useState } from "react";
import { LoginContext } from "../../../../context/ContextProvider";
import { Button } from "reactstrap";
import { getId } from "../../../../provisioning/elements/FormInput";
import ModalTextEditor from "../../../../elements/ModalTextEditor";
import CenterModal from "../../../../elements/CenterModal";
import ThemeSwitch from "../../../../elements/ThemeSwitch";

export const defaultTermsOfService = `<h2 style="text-align:center;">Terms of Service</h2>
<p>By accessing or using Smart WiFi, you agree to comply with and be bound by the following terms and conditions of use.</p>
<ol>
  <li><strong>Use of the App</strong>: You agree to use the app for lawful purposes only.</li>
  <li><strong>Privacy Policy</strong>: Our Privacy Policy governs the collection and use of your personal information.</li>
  <li><strong>Termination</strong>: We may terminate or suspend your account and access to the app at our discretion.</li>
  <li><strong>Disclaimer</strong>: The app is provided "as is" without any warranties, expressed or implied.</li>
</ol>
<p>If you do not agree to these terms, please do not use our application.</p>
`;

const TermsAndConditionsSubstep = (props) => {
  // login context
  const loginContext = useContext(LoginContext);
  const preloginPreview = loginContext.preloginPreview;

  // get path
  const fullPath = getId(props);
  const attribute = `${fullPath}.custom`;

  // modal states
  const [defaultModalOpen, setDefaultModalOpen] = useState(false);
  const [customModalOpen, setCustomModalOpen] = useState(false);

  // read and write
  const { watch, setValue } = props;

  // set initial state
  useEffect(() => {
    setValue(attribute, null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customHTML = watch(attribute);
  const isCustom = customHTML != null;

  // handlers
  const handleDefault = () => {
    setValue(attribute, null);
    setDefaultModalOpen(true);
  };

  const handleCustom = () => {
    setCustomModalOpen(true);
  };

  const handlePreloginPreviewEnabled = (enabled) => {
    loginContext.updateState({ preloginPreview: enabled });
  };

  return (
    <div>
      <div className="d-flex">
        <Button
          color="info"
          size="lg"
          outline={isCustom}
          onClick={handleDefault}
        >
          Default
        </Button>
        <Button
          className="ms-2"
          color="info"
          size="lg"
          outline={!isCustom}
          onClick={handleCustom}
        >
          Custom
        </Button>
      </div>
      <ThemeSwitch
        className="my-1"
        checked={preloginPreview}
        onChange={(checked) => handlePreloginPreviewEnabled(checked)}
        text="Preview"
      />
      <CenterModal isOpen={defaultModalOpen} toggle={() => setDefaultModalOpen(prev => !prev)} size="lg">
        <div dangerouslySetInnerHTML={{ __html: defaultTermsOfService }} />
      </CenterModal>
      <ModalTextEditor
        isOpen={customModalOpen}
        toggle={() => {}}
        initialHTML={isCustom ? customHTML : ""}
        forceSetHTML={defaultTermsOfService}
        onUpdate={(html) => setValue(attribute, html)}
        onDone={() => setCustomModalOpen(false)}
      />
    </div>
  );
};

export default TermsAndConditionsSubstep;
